// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ImportProcessResult  {
    _originalTypeClassName = "Loom.BO.ImportProcessResult";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ImportProcessResult.translate = translateService;
}
this.Messages = [];
this.LastPage = false;
this.PageIndex = null;
this.TasksImported = null;
this.TasksRetrieved = null;
this.ImportPercentage = null;
this.Failure = false;
this.ImportProcessResultKey = null;
this._key = this.ImportProcessResultKey = 0; 
}

static translate: TranslateService;
_key: any;
LastPage:any;
PageIndex:any;
TasksImported:any;
TasksRetrieved:any;
ImportPercentage:any;
Failure:any;
Messages:any;
private _ImportProcessResultKey:any;
get ImportProcessResultKey(): any {
    return this._ImportProcessResultKey;
  }
set ImportProcessResultKey(value: any) {
    this._ImportProcessResultKey = value;
    this._key = value;
  }
static setMessages = ($this, items) => {
                if (items == null) items = [];
                if ($this.Messages == null) $this.Messages = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Messages.length > 0) {
                    Domain.ImportProcessResult.removeMessages($this, $this.Messages[0]);
                }

                Domain.ImportProcessResult.addManyMessages($this, copyItems);
            }
static addManyMessages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ImportProcessResult.addMessages($this, items[i]);
                }
            }
static addMessages = ($this, item) => {
                if ($this.Messages == null) $this.Messages = [];
                if (item == null || $this.Messages.indexOf(item) > -1) return;
                $this.Messages.push(item);
}
static addRangeMessages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ImportProcessResult.addMessages($this, item));
            }
static removeMessages = ($this, item) => {
                if ($this == null || $this.Messages == null || $this.Messages.indexOf(item) === -1) return;
                var _index = $this.Messages.indexOf(item);
                $this.Messages.splice(_index, 1);
}
static clearMessages = ($this) => { $this.Messages = null; }

static AddMessage($this: any, msg: any,type: any): any{let message = new Domain.ImportProcessMessage();
message.Type = type;
message.Message = msg;
$this?.Messages?.add(message);
}
static GetImportPercentage($this: any): any{if ((CLMS.Framework.Number.GreaterThan(() => $this.TasksRetrieved, () => 0))) {return Joove.Common.safeNumber((Joove.Common.safeNumber((parseFloat(($this?.TasksImported) as any))) / Joove.Common.safeNumber((parseFloat(($this?.TasksRetrieved) as any))))) * Joove.Common.safeNumber(100);}
return 0;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ImportProcessResultKey == null || $this.ImportProcessResultKey == 0;
            }


}